// extracted by mini-css-extract-plugin
export var lg = "_fs-4";
export var md = "_fs-3";
export var reactTimePickerInputGroupAmPm = "_fs-6";
export var redoTimePicker = "_fs-0";
export var sm = "_fs-2";
export var xl = "_fs-5";
export var xs = "_fs-1";